import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaSqlQueryApi {
  private http = inject(SiaHttpService);

  private readonly _controller: string = 'sql-query';

  executeQuery(query: string, parameters: any = undefined, connectionString: string | null | undefined): Promise<any> {
    return this.http.post(`${this._controller}/command`, {
      query: query,
      connectionString: connectionString,
      parameters: parameters
        ? JSON.stringify(parameters, function (k, v) {
            return v === undefined ? null : v;
          })
        : undefined,
    });
  }

  execSP(spName: string, parameters: any, connectionString: string | null | undefined): Promise<any> {
    return this.http.post(`${this._controller}/stored-procedure`, {
      name: spName,
      parameters: JSON.stringify(parameters, function (k, v) {
        return v === undefined ? null : v;
      }),
      connectionStringName: connectionString,
    });
  }

  retriveTopN(viewSchema: string, viewName: string, n: number, connectionStringName: string = 'CoreDB'): Promise<any> {
    return this.http.get(`${this._controller}/top-n/${connectionStringName}/${viewSchema}/${viewName}/${n}`);
  }
}
